module.exports = __webpack_public_path__ + "static/hurdyGurdy-fd3cff6440ae95b90d866ce33d6e30b9.mp3";